import { render, staticRenderFns } from "./topic-product.vue?vue&type=template&id=5c73d07d&scoped=true"
import script from "./topic-product.vue?vue&type=script&lang=js"
export * from "./topic-product.vue?vue&type=script&lang=js"
import style0 from "./topic-product.vue?vue&type=style&index=0&id=5c73d07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73d07d",
  null
  
)

export default component.exports